import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useContext, useMemo } from 'react';
import { createUseStyles, Button } from '@Sage/hoi-poi-ui';
import { CopilotContext } from "../../../Context";
import styles from "./styles";
const useStyles = createUseStyles(styles);
const Actions = _ref => {
  let {
    actions,
    finished
  } = _ref;
  const {
    featureMethods
  } = useContext(CopilotContext);
  const classes = useStyles();
  const renderActions = useMemo(() => {
    if (!(actions !== null && actions !== void 0 && actions.length)) return null;
    return actions.map((action, index) => {
      var _featureMethods$ssm;
      const {
        type,
        params
      } = action;
      const method = (_featureMethods$ssm = featureMethods.ssm) === null || _featureMethods$ssm === void 0 ? void 0 : _featureMethods$ssm[type];
      if (!method) return null;
      const buttonProps = {
        onClick: () => method.action(params),
        children: method.cta,
        type: 'primary',
        size: 'small'
      };
      return /*#__PURE__*/React.createElement(Button, _extends({
        key: `action-${index}`
      }, buttonProps));
    }).filter(Boolean);
  }, [actions, featureMethods.ssm]);
  if (!renderActions || !finished) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, renderActions);
};
export default /*#__PURE__*/memo(Actions);